/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-category.reducer';

export const PatientCategoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientCategoryEntity = useAppSelector(state => state.patientCategory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientCategoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientCategory.detail.title">PatientCategory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientCategory.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientCategoryEntity.id}</dd>
          <dt>
            <span id="categoryCode">
              <Translate contentKey="tinyMedicRestApp.patientCategory.categoryCode">Category Code</Translate>
            </span>
          </dt>
          <dd>{patientCategoryEntity.categoryCode}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.patientCategory.description">Description</Translate>
            </span>
          </dt>
          <dd>{patientCategoryEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientCategory.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientCategoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientCategory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientCategoryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.patientCategory.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{patientCategoryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientCategory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientCategoryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.patientCategory.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{patientCategoryEntity.timestampEntry}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.patientCategory.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{patientCategoryEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.patientCategory.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{patientCategoryEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.patientCategory.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{patientCategoryEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.patientCategory.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{patientCategoryEntity.modifiedByID}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientCategory.hospital">Hospital</Translate>
          </dt>
          <dd>{patientCategoryEntity.hospital ? patientCategoryEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-category" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-category/${patientCategoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientCategoryDetail;
